/* One centered start card; keep Play reachable in short windows and with
   browser zoom or the mobile keyboard reducing the available height. */
#join{left:50%;top:50%;transform:translate(-50%,-50%);z-index:6;
  width:min(340px,calc(100vw - 32px));padding:14px 16px 16px;
  max-height:calc(100dvh - 24px);overflow-y:auto;
  display:flex;flex-direction:column;gap:10px;text-align:left;
  pointer-events:auto}
#join-lead{font-size:.72rem;line-height:1.55;color:var(--ink);opacity:.9}
#join-deny{font-size:.72rem;line-height:1.55;color:var(--ink);
  border-left:2px solid var(--accent);padding-left:9px}
#join-deny[hidden]{display:none}
#join-name{width:100%;font-family:inherit;font-size:.9rem;color:var(--ink);
  background:transparent;border:1px solid var(--edge);border-radius:3px;
  padding:9px 10px}
#join-name::placeholder{color:var(--dim);opacity:.7}
#join-name:focus{outline:none;border-color:var(--accent)}
#join-play{color:var(--accent)}
